module.exports = __webpack_public_path__ + "static/img/zt1-pic6.a0790c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt1-pic6.jpg
// module id = M9nr
// module chunks = 171